export default __webpack_public_path__ + "static/media/arrow-left.b7dd65a5.svg";